(function () {
  "use strict";
  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (prefersReducedMotion) {
    document.querySelectorAll("video[autoplay]").forEach(function (v) {
      v.removeAttribute("autoplay"); v.pause();
    });
  }

  var header = document.querySelector(".site-header");
  if (header) {
    var onScroll = function () { header.classList.toggle("is-scrolled", window.scrollY > 8); };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  var navToggle = document.querySelector(".nav-toggle");
  var navLinks = document.querySelector(".nav-links");
  if (navToggle && navLinks) {
    navToggle.addEventListener("click", function () {
      var open = navLinks.classList.toggle("is-open");
      navToggle.setAttribute("aria-expanded", String(open));
    });
  }

  var revealEls = document.querySelectorAll(".reveal");
  if (revealEls.length && "IntersectionObserver" in window && !prefersReducedMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add("is-visible"); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -40px 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---------- Produktbilder-Slider (statt untereinander gestapelt) ---------- */
  document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
    if (gallery.classList.contains("gallery--single")) return;
    var track = gallery.querySelector("[data-gallery-track]");
    var slides = track.children;
    var dots = gallery.querySelectorAll("[data-gallery-dot]");

    function setActiveDot(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === index);
      });
    }

    function activeIndex() {
      var current = 0;
      dots.forEach(function (dot, i) {
        if (dot.classList.contains("is-active")) current = i;
      });
      return current;
    }

    function goTo(index) {
      index = Math.max(0, Math.min(slides.length - 1, index));
      slides[index].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      setActiveDot(index);
    }

    var prevBtn = gallery.querySelector("[data-gallery-prev]");
    var nextBtn = gallery.querySelector("[data-gallery-next]");
    if (prevBtn) {
      prevBtn.addEventListener("click", function () { goTo(activeIndex() - 1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", function () { goTo(activeIndex() + 1); });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () { goTo(i); });
    });

    /* Punkt-Anzeige folgt auch echtem Swipe/Drag, nicht nur Klicks */
    var scrollTimer = null;
    track.addEventListener(
      "scroll",
      function () {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(function () {
          var width = track.clientWidth || 1;
          var idx = Math.round(track.scrollLeft / width);
          setActiveDot(Math.max(0, Math.min(slides.length - 1, idx)));
        }, 80);
      },
      { passive: true }
    );
  });

  /* ---------- Altersstufen-Filter (Collection-Seite) ---------- */
  var ageFilter = document.querySelector("[data-age-filter]");
  if (ageFilter) {
    var ageToggle = ageFilter.querySelector(".age-filter-toggle");
    var agePanel = ageFilter.querySelector(".age-filter-panel");
    var ageCount = ageFilter.querySelector(".age-filter-count");
    var ageClear = ageFilter.querySelector(".age-filter-clear");
    var ageChecks = ageFilter.querySelectorAll('input[type="checkbox"]');
    var cards = document.querySelectorAll("[data-age]");
    var countEl = document.querySelector(".filter-count");

    var selectedAges = function () {
      var ages = [];
      ageChecks.forEach(function (box) {
        if (box.checked) ages.push(box.value);
      });
      return ages;
    };

    var applyAgeFilter = function () {
      var ages = selectedAges();
      var shown = 0;
      cards.forEach(function (card) {
        var cardAges = (card.dataset.age || "").split(" ");
        var match =
          ages.length === 0 ||
          ages.some(function (a) {
            return cardAges.indexOf(a) !== -1;
          });
        card.classList.toggle("is-hidden", !match);
        if (match) shown++;
      });
      if (countEl) {
        countEl.textContent = shown + " " + (shown === 1 ? "Spielzeug" : "Spielzeuge") + " angezeigt";
      }
    };

    var updateAgeToggleLabel = function () {
      var n = selectedAges().length;
      if (ageCount) ageCount.textContent = n > 0 ? " (" + n + ")" : "";
    };

    var closeAgePanel = function () {
      agePanel.hidden = true;
      ageToggle.setAttribute("aria-expanded", "false");
    };

    ageToggle.addEventListener("click", function () {
      var willOpen = agePanel.hidden;
      agePanel.hidden = !willOpen;
      ageToggle.setAttribute("aria-expanded", String(willOpen));
    });

    document.addEventListener("click", function (e) {
      if (!ageFilter.contains(e.target)) closeAgePanel();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !agePanel.hidden) {
        closeAgePanel();
        ageToggle.focus();
      }
    });

    ageChecks.forEach(function (box) {
      box.addEventListener("change", function () {
        updateAgeToggleLabel();
        applyAgeFilter();
      });
    });

    if (ageClear) {
      ageClear.addEventListener("click", function () {
        ageChecks.forEach(function (box) { box.checked = false; });
        updateAgeToggleLabel();
        applyAgeFilter();
        closeAgePanel();
      });
    }

    /* Vorauswahl über ?alter=... aus dem Kopfmenü-Untermenü */
    try {
      var urlParams = new URLSearchParams(window.location.search);
      var urlAge = urlParams.get("alter");
      if (urlAge) {
        var urlAgeValue = urlAge === "5-plus" ? "5+" : urlAge;
        ageChecks.forEach(function (box) {
          if (box.value === urlAgeValue) box.checked = true;
        });
        updateAgeToggleLabel();
        applyAgeFilter();
      }
    } catch (e) {}
  }

  /* ---------- Anzahl-Rabattstufen (Produktseite) ---------- */
  document.querySelectorAll("[data-qty-tiers]").forEach(function (wrap) {
    var input = wrap.parentElement.querySelector("[data-qty-input]");
    var tiers = wrap.querySelectorAll(".qty-tier");
    tiers.forEach(function (tier) {
      tier.addEventListener("click", function () {
        tiers.forEach(function (t) {
          t.classList.remove("is-active");
          t.setAttribute("aria-pressed", "false");
        });
        tier.classList.add("is-active");
        tier.setAttribute("aria-pressed", "true");
        if (input) input.value = tier.dataset.qty;
      });
    });
  });
})();
